(function () {
  // Theme 'smt-loadding' class blijft soms hangen -> forceer weg
  try { document.documentElement.classList.remove('smt-loadding'); } catch (e) {}

  function initAiFaq(root) {
    if (!root || root.dataset.aiFaqReady === '1') return;
    root.dataset.aiFaqReady = '1';

    var items = Array.from(root.querySelectorAll('.ai-faq-item'));
    var searchInput = root.querySelector('.ai-faq-search-input');
    var catButtons = Array.from(root.querySelectorAll('.ai-faq-cat'));
    var chipButtons = Array.from(root.querySelectorAll('.ai-faq-chip'));
    var empty = root.querySelector('.ai-faq-empty');
    var activeCat = '*';

    function normalize(str) {
      return (str || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    function setActiveCat(cat) {
      activeCat = cat;
      var activeBtn = null;
      catButtons.forEach(function (b) {
        var isMatch = (b.dataset.aiCat || '*') === cat;
        b.classList.toggle('is-active', isMatch);
        b.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        if (isMatch) activeBtn = b;
      });
      // Op mobile: scroll actieve knop naar midden zodat hij altijd zichtbaar is
      if (activeBtn && activeBtn.scrollIntoView) {
        try {
          activeBtn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        } catch (e) {}
      }
    }

    function filter() {
      var q = normalize(searchInput ? searchInput.value : '').trim();
      var visible = 0;
      items.forEach(function (item) {
        var cat = item.dataset.aiCategory || '';
        var text = normalize(item.textContent);
        var matchCat = activeCat === '*' || cat === activeCat;
        var matchQ = !q || text.includes(q);
        var show = matchCat && matchQ;
        item.hidden = !show;
        if (show) visible++;
      });
      if (empty) empty.hidden = visible > 0;
    }

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });

    if (searchInput) {
      var timer;
      searchInput.addEventListener('input', function () {
        // Zodra er wordt getypt: reset naar 'Alle' zodat matches niet door filter verborgen blijven
        if (searchInput.value.trim().length > 0 && activeCat !== '*') {
          setActiveCat('*');
        }
        clearTimeout(timer);
        timer = setTimeout(filter, 120);
      });

      // Hele witte zoekbalk-wrap klikbaar maken (makkelijker op mobile)
      var searchWrap = root.querySelector('.ai-faq-search');
      if (searchWrap) {
        searchWrap.addEventListener('click', function (e) {
          if (e.target !== searchInput) {
            e.preventDefault();
            e.stopPropagation();
            searchInput.focus();
            try { searchInput.click(); } catch (err) {}
          }
        }, { capture: true });
        // iOS touch
        searchWrap.addEventListener('touchend', function (e) {
          if (e.target === searchInput || e.target.matches('a, button')) return;
          if (document.activeElement !== searchInput) {
            searchInput.focus();
          }
        }, { passive: true });
      }
    }

    catButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Als er een zoekterm staat, leegmaken — anders blijf je alleen de matches binnen de categorie zien
        if (searchInput && searchInput.value) {
          searchInput.value = '';
        }
        setActiveCat(btn.dataset.aiCat || '*');
        filter();
      });
    });

    chipButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.dataset.aiSuggested || btn.textContent.trim();
        setActiveCat('*');
        if (searchInput) {
          searchInput.value = q;
          searchInput.focus({ preventScroll: true });
          try {
            searchInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } catch (e) {}
        }
        filter();

        var matches = items.filter(function (item) {
          return !item.hidden;
        });
        if (matches.length === 1) {
          matches[0].open = true;
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ai-faq]').forEach(initAiFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
